import React, { useEffect, useState } from "react";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import { navLinks } from "./MegafonView";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import ActionButton from "../../components/button/ActionButton";
import { getAccessToken } from "../../services/baseReuqest";
import AnyField from "../../components/fields/AnyField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {getAllMegafonChannel} from "../../services/megafon";

const useStyles = makeStyles(theme => ({
    btn: {
        backgroundColor: "#f0f0f0",
        border: "none",
        cursor: "pointer",
        padding: "5px",
        borderRadius: "4px",
        transition: "background-color 0.3s ease",

        "&:hover": {
            backgroundColor: "#d9d9d9",
        },
    }
}))

export default function MegafonPage() {
    const {t} = useTranslation();
    const classes = useStyles();

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
    const [rowData, setRowData] = useState({});
    const [originalRowData, setOriginalRowData] = useState({});
    const [errorDialog, setErrorDialog] = useState(false);
    const [successDialog, setSuccessDialog] = useState(false);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const [refreshTable, setRefreshTable] = useState(false);
    const [isOpenDeleteMegafonDialog, setIsOpenDeleteMegafonDialog] = useState(false);
    const [newMegafon, setNewMegafon] = useState({
        name: '',
        phoneNumber: '',
        amountOfLetters: '',
        queue: '',
        login: '',
        password: '',
    });
    const [disableBtn, setDisableBtn] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const columnData = [
        {
            id: 'action', numeric: false, disableSorting: true, label: 'Action',
            processValue: () => {
                return (
                    <>
                        <button className={classes.btn}>{t("Settings")}</button>
                    </>
                );

            },
            onClick: () => {
                // openMenuDialog(val);
            }
        },
        {id: 'phoneNumber', numeric: false, disableSorting: true, label: 'Phone'},
        {id: 'name', numeric: false, disableSorting: true, label: 'Name'},
        {id: 'queue', numeric: false, disableSorting: true, label: 'Queue'}
    ]

    useEffect(() => {
        if (newMegafon.phoneNumber.length && newMegafon.name.length && newMegafon.amountOfLetters.length &&
            newMegafon.queue.length && newMegafon.login.length && newMegafon.password.length) {
            setDisableBtn(false)
        } else {
            setDisableBtn(true)
        }
    }, [newMegafon]);

    const getTableData = (page, per_page, order, order_by) => {
        return getAllMegafonChannel(page, per_page, order, order_by);
    }

    const openMenuDialog = (row) => {
        setRowData(row);
        setOriginalRowData(row);
        setIsOpen(!isOpen);
    };

    const handleCloseEditDialog = () => {
        setIsOpenEditDialog(!isOpenEditDialog);
        setRowData(originalRowData);
    }

    const deleteMegafonDialog = () => {
        setIsOpenDeleteMegafonDialog(!isOpenDeleteMegafonDialog);
    }

    const deleteMegafon = () => {
        fetch(`/api/megafon/${rowData.id}/delete`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            }
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.success) {
                setIsOpen(!isOpen);
                deleteMegafonDialog();
                successResponse();
                setRefreshTable(!refreshTable);
            } else {
                errorOccurred();
                setErrorMessage(data.error.message);
            }
        });
    }

    const editMegafon = () => {
        const payload = {
            name: rowData.name ?? null,
            phoneNumber: Number(rowData.phoneNumber) ?? null,
            amountOfLetters: Number(rowData.amountOfLetters) ?? null,
            queue: rowData.queue ?? null,
            login: rowData.login ?? null,
            password: rowData.password ?? null,
        };

        fetch(`/api/megafon/${rowData.id}/edit`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
            body: JSON.stringify(payload)
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.success) {
                const currentRow = data.data.find(item => item.id === rowData.id);
                setRowData(currentRow);
                setOriginalRowData(currentRow);
                successResponse();
                setRefreshTable(!refreshTable);
            } else {
                errorOccurred();
                setErrorMessage(data.error.message);
            }
        });
        setIsOpenEditDialog(false);
    }

    const handleChange = (prop) => (e) => {
        const value = e.target.value;

        if (prop === "queue") {
            const filteredValue = value.replace(/[^a-zA-Z0-9._]/g, "");

            setRowData(prev => {
                return {
                    ...prev,
                    [prop]: filteredValue,
                };
            })
        } else if (prop === "amountOfLetters") {
            const filteredValue = value.replace(/[^0-9]/g, "");

            setRowData(prev => {
                return {
                    ...prev,
                    [prop]: filteredValue,
                };
            })
        }  else {
            setRowData(prev => {
                return {
                    ...prev,
                    [prop]: value,
                };
            })
        }
    }

    const handleChangeCreate = (prop) => (e) => {
        const value = e.target.value;

        if (prop === "queue") {
            const filteredValue = value.replace(/[^a-zA-Z0-9._]/g, "");

            setNewMegafon({
                ...newMegafon,
                [prop]: filteredValue,
            });
        } else if (prop === "amountOfLetters") {
            const filteredValue = value.replace(/[^0-9]/g, "");

            setNewMegafon({
                ...newMegafon,
                [prop]: filteredValue,
            });
        } else {
            setNewMegafon({
                ...newMegafon,
                [prop]: value,
            });
        }
    };

    const isOpenCreateDialog = () => {
        setIsOpenCreate(!isOpenCreate);
    }

    const createMegafonChannel = () => {
        const payload = {
            name: newMegafon.name ?? null,
            phoneNumber: Number(newMegafon.phoneNumber) ?? null,
            amountOfLetters: Number(newMegafon.amountOfLetters) ?? null,
            queue: newMegafon.queue ?? null,
            login: newMegafon.login ?? null,
            password: newMegafon.password ?? null,
        };

        fetch(`/api/megafon/create`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
            body: JSON.stringify(payload)
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.success) {
                successResponse();
                setIsOpenCreate(false);
                setRefreshTable(!refreshTable);
            } else {
                errorOccurred();
                setErrorMessage(data.error.message);
            }
        });
    }

    const errorOccurred = () => {
        setErrorDialog(true);
        setTimeout(() => {
            setErrorDialog(false);
            setErrorMessage('');
        }, 2000)
    }

    const successResponse = () => {
        setSuccessDialog(true);
        setTimeout(() => {
            setSuccessDialog(false);
        }, 2000)
    }

    return (
        <>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                <ActionButton onClick={isOpenCreateDialog}>{t("Create megafon")}</ActionButton>
            </LeftBar>
            <Content title={t("Megafon for serial mailing")}>
                <DataTable
                    columnData={columnData}
                    dataFunc={getTableData}
                    selector={false}
                    onClick={openMenuDialog}
                    refresh={refreshTable}
                    pagination={true}
                />
            </Content>

            <Dialog open={isOpen} onClose={openMenuDialog}>
                <DialogTitle id="dialog-title">{t("Settings")} {rowData.phoneNumber}</DialogTitle>
                <div style={{padding: "0 24px 24px"}}>
                    <ActionButton onClick={handleCloseEditDialog}>{t("Edit")}</ActionButton>
                    <ActionButton onClick={deleteMegafonDialog}>{t("Delete")}</ActionButton>
                </div>
            </Dialog>

            <Dialog
                open={isOpenEditDialog}
                onClose={handleCloseEditDialog}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                fullWidth
            >
                <DialogTitle id="dialog-title">{t("Edit megafon channel")}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid item xs={6}>
                            <AnyField
                                id="Phone"
                                label={t("Phone")}
                                value={(rowData?.phoneNumber) ? rowData.phoneNumber : ''}
                                onChange={handleChange('phoneNumber')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="name"
                                label={t("Name")}
                                value={(rowData?.name) ? rowData.name : ''}
                                onChange={handleChange('name')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="login"
                                label={t("Login")}
                                value={(rowData?.login) ? rowData.login : ''}
                                onChange={handleChange('login')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <AnyField
                                id="queue"
                                label={t("Queue")}
                                value={(rowData?.queue) ? rowData.queue : ''}
                                placeholder={"a–Z, 0-9, \".\", \"_\", без пробелов"}
                                onChange={handleChange('queue')}
                                disabled={isOpenEditDialog}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="amountOfLetters"
                                label={t("Max amount of letters")}
                                value={(rowData?.amountOfLetters) ? rowData.amountOfLetters : ''}
                                onChange={handleChange('amountOfLetters')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="password"
                                label={t("Password")}
                                value={(rowData?.password) ? rowData.password : ''}
                                onChange={handleChange('password')}
                                visible={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={editMegafon} color="primary">OK</Button>
                    <Button onClick={handleCloseEditDialog} color="primary">Отмена</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isOpenCreate}
                onClose={() => setIsOpenCreate(false)}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                fullWidth
            >
                <DialogTitle id="dialog-title">{t("Create megafon channel")}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid item xs={6}>
                            <AnyField
                                id="Phone"
                                label={t("Phone")}
                                value={(newMegafon?.phoneNumber) ? newMegafon.phoneNumber : ''}
                                onChange={handleChangeCreate('phoneNumber')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="name"
                                label={t("Name")}
                                value={(newMegafon?.name) ? newMegafon.name : ''}
                                onChange={handleChangeCreate('name')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="login"
                                label={t("Login")}
                                value={(newMegafon?.login) ? newMegafon.login : ''}
                                onChange={handleChangeCreate('login')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <AnyField
                                id="queue"
                                label={t("Queue")}
                                value={(newMegafon?.queue) ? newMegafon.queue : ''}
                                placeholder={"a–Z, 0-9, \".\", \"_\", без пробелов"}
                                onChange={handleChangeCreate('queue')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="amountOfLetters"
                                label={t("Max amount of letters")}
                                value={(newMegafon?.amountOfLetters) ? newMegafon.amountOfLetters : ''}
                                onChange={handleChangeCreate('amountOfLetters')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                            <AnyField
                                id="password"
                                label={t("Password")}
                                value={(newMegafon?.password) ? newMegafon.password : ''}
                                onChange={handleChangeCreate('password')}
                                visible={true}
                                required={true}
                                style={{ width: "80%" }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={createMegafonChannel} disabled={disableBtn} color="primary">Создать</Button>
                    <Button onClick={isOpenCreateDialog} color="primary">Отмена</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={successDialog} style={{ bottom: 30 }}>
                <DialogTitle id="dialog-title">{t("Success")}</DialogTitle>
            </Dialog>

            <Dialog open={errorDialog} style={{ bottom: 30 }}>
                <DialogTitle id="dialog-title">{errorMessage}</DialogTitle>
            </Dialog>

            <Dialog open={isOpenDeleteMegafonDialog}>
                <div style={{padding: "0 80px 0 80px"}}>
                    <DialogTitle>{t("Delete megafon")}</DialogTitle>
                    <DialogActions>
                        <ActionButton style={{padding: "0 20px 0 20px"}} onClick={deleteMegafon} color="secondary">{t("Confirm")}</ActionButton>
                        <ActionButton style={{padding: "0 10px 0 10px"}} onClick={deleteMegafonDialog} color="secondary">{t("Cancel")}</ActionButton>
                    </DialogActions>
                </div>
            </Dialog>
        </>
    )
}